import * as Vibrant from 'node-vibrant'

export const getBlobFromUrl = async imgURL => {
  const blob = await fetch(imgURL).then(result => result.blob())
  return blob
}

export const convertBlobToBase64 = blob => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}

export const convertToEncodeURI = (baseURL, params) => {
  let paramsURI = ''
  const paramsKeys = Object.keys(params)
  paramsKeys.forEach(key => {
    paramsURI = `${paramsURI}${key}=${encodeURIComponent(params[key])}&`
  })
  return `${baseURL}?${paramsURI}`
}

export const getPaletteColorFromImageBase64 = imgBase64 => {
  return Vibrant.from(imgBase64).getPalette()
}

export const getConfigForNetwork = () => {
  if (window.location.href.includes('dj.nutchy.dev')) {
    return {
      env: 'production',
      backendURL: 'https://spotify-dj-backend.herokuapp.com',
      frontendURL: 'https://dj.nutchy.dev'
    }
  } else {
    // local network
    return {
      env: 'local',
      backendURL: 'http://localhost:3000',
      frontendURL: 'http://localhost:8080'
    }
  }
}
